export const constants = Object.freeze({
  STATUS_ENABLED: "enabled",
  STATUS_BLOCKED: "blocked",
  CREATED_AT: "createdAt",
  STATUS_FAIL: "fail",
  SIGN_IN: "signin",
  QR_CODE: "qrcode",
  VERIFICATION_CODE: "verificationCode",
});
